var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab__content clear"},[(_vm.tournament.type == 1)?_c('div',{staticClass:"floated-box right"},[_c('discord-widget',{attrs:{"id":"discord"}})],1):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.tournament.info)}})])}
var staticRenderFns = []

export { render, staticRenderFns }